<script lang="ts" context="module">
  export let useNewComponent = true;
</script>

<script lang="ts">
  export let useNewComponent = true;
</script>

{#if useNewComponent}
  <slot name="new_component"></slot>
{:else}
  <slot name="current_component"></slot>
{/if}
